<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less">
@import url('./assets/style/reset.less');
@import url('./assets/style/style.less');

html, body {
    width: 100%;
    height: 100%;
    font-size: 62.5%;
}
#app, .content {
    width: 100%;
    height: 100%;
}
</style>


